<template>
  <form @submit.prevent="submit">
    <div class="configuration-code-input">
      <form-input
        id="configurationCode"
        v-model="configurationCode"
        title="configurationCode"
        placeholder="Configuratiecode"
        :show-label="false"
      />
      <app-button
        button-type="submit"
        :disabled="isLoading"
        data-qa="open-configuration-code-button"
      >
        <span v-if="!isLoading">Open</span>
        <loader v-else />
      </app-button>
    </div>
  </form>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import ConfigurationHelper from '@/helpers/ConfigurationHelper'
import { EventBus } from '@/plugins/event-bus'
import ConfigurationApi from '@/api/server/Configuration'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: {
    Loader,
    AppButton,
    FormInput,
  },
  props: {
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configurationCode: '',
      isIncorrectConfigurationCode: false,
      isLoading: false,
    }
  },
  methods: {
    async submit() {
      this.configurationCode = this.configurationCode.trim()

      if (ConfigurationHelper.isValidShoppingCartId(this.configurationCode)) {
        await this.submitCartId(this.configurationCode)
        return
      }

      await this.submitConfigurationCode(this.configurationCode)
    },
    async submitCartId(cartId) {
      var shoppingCart = await this.getShoppingCart(cartId)
      if (shoppingCart === null) {
        EventBus.$emit(
          'notification-warning',
          `De configuratiecode ${cartId} kan niet worden opgehaald`
        )
        return
      }

      let params = {
        ...this.$route.params,
        cartId: cartId,
      }

      this.$router.push({
        name: 'new-shopping-cart-page',
        params,
        query: this.$route.query,
      })
    },
    async submitConfigurationCode(configurationCode) {
      if (!ConfigurationHelper.isValidConfigurationCode(configurationCode)) {
        EventBus.$emit('notification-warning', 'Vul een juiste configuratiecode in')
        return
      }

      var configuration = await this.getConfiguration(configurationCode)
      if (configuration === null) {
        EventBus.$emit(
          'notification-warning',
          `De configuratiecode ${configurationCode} kan niet worden opgehaald`
        )
        return
      }

      let params = {
        ...this.$route.params,
        configurationCode: configurationCode,
      }

      if (this.isPurchaseOrder) this.$router.push({ name: 'new-purchase-order-page', params })
      else
        this.$router.push({
          name: 'new-configuration-page',
          params,
          query: this.$route.query,
        })
    },
    async getShoppingCart(cartId) {
      try {
        this.isLoading = true
        return await ConfigurationApi.getShoppingCart(cartId)
      } finally {
        this.isLoading = false
      }
    },
    async getConfiguration(configurationCode) {
      try {
        this.isLoading = true
        return await ConfigurationApi.getConfiguration(configurationCode)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.configuration-code-input {
  display: flex;
  flex-flow: row wrap;
}
</style>
